import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function Cancel() {
  return (
    <div data-testid="cancel-page" className="bg-white min-h-screen flex flex-col text-ink">
      <Header />
      <main className="flex-1 grid place-items-center px-6 pt-32 pb-20">
        <div className="max-w-2xl w-full text-center">
          <div className="font-mono-spec text-[11px] uppercase tracking-[0.22em] text-brand mb-3 font-medium">Checkout Cancelled</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-[-0.035em] text-ink leading-[1.05]">
            No worries. Your spot is still{" "}
            <span className="font-serif-em italic text-brand font-light">open.</span>
          </h1>
          <p className="mt-6 text-lg text-ink/70">
            Whenever you&apos;re ready, head back and complete checkout. The live build lab kicks off June 23, 2026 at 7:00 PM EST.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/#register" data-testid="cancel-retry-link">
              <Button className="btn-ink rounded-full h-12 px-6 font-medium">Try Again</Button>
            </Link>
            <Link to="/" data-testid="cancel-home-link">
              <Button variant="outline" className="btn-outline-ink rounded-full h-12 px-6 font-medium">
                <ArrowLeft size={16} className="mr-2" />
                Back to Home
              </Button>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
